import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const TMTNIGHTOUT_PROMO_CODE = "TMTNIGHTOUT"
const TMTSPA_PROMO_CODE = "TMTSPA"
const TMTREEBOK_PROMO_CODE = "TMTREEBOK"

export const NursesTeachersGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(TMTSPA_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (boldDescription , description, logoUrl, promoCode) => ({disabled, handleClick}) => {
    return (
      <> 
        <img src={logoUrl} alt="NursesTeachers Logo" className="mb-3"/>
        <p><b>{boldDescription}</b>{description}</p>
        <Button
        type="button"
        className="btn"
        primary
        disabled={disabled}
        onClick={() => {
          setSubmissionPromoCode(promoCode)
          handleClick()
        }}
        >
          Continue
        </Button>
       </>)
  }

  const submitButtons = [
    getButton(
      ` `,
      `Enjoy a night out with 2 movie tickets (up to $15/ticket) and a $25 Restaurant.com credit.`,
      "images/NursesTeachers/nightoutlogo.jpg",
      TMTNIGHTOUT_PROMO_CODE
    ),
    getButton(
      ` `,
      `Enjoy a $50 Spa & Wellness Gift Card.`,
      "images/NursesTeachers/Stacked_spa&wellnesslogo_FINAL_2020_teal1.png",
      TMTSPA_PROMO_CODE,
    ),
    getButton(
      ` `,
      `Enjoy a $50 Reebok credit.`,
      "images/NursesTeachers/Reebok.Logo-image.png",
      TMTREEBOK_PROMO_CODE,
    ),
  ];

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>In honor of their special weeks this May (National Teacher's Week May 1 - 7 and National Nurse's Week May 6 - 12), T-Mobile wants to thank our Nurse and Teacher customers with a special gift of their choice (1 of 3). Eligible customers are K-12 Teachers, University and College Teachers, Advanced Registered Nurse Practitioners, Advanced Practice Registered Nurses, Certified Nursing Assistants, Certified Nurse Midwifes, Licensed Practical Nurses, Nurse Anesthetists, Nurse Practitioners, and Registered Nurses. </p>
           
            <p>
            Enter your T-Mobile phone number and choose one of the below offers to redeem.  You will be prompted to log in to your account and verify your status as a Nurse or Teacher.</p>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{marginBottom: "6px"}}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto"/>
        </div>
       
      </div>
    </section>
  )
}
